/**
 * GreatPrice Wholesale Pure Price & Margin Governor Engine
 * - Pure Mathematical Evaluation: NO generic category/tag filters
 * - Driven 100% by Individual Product Selling Price and MRP Discount
 * - Static Limits: Anti-hoarding price brackets (<₹20: 100, ₹20-99: 50, ₹100-499: 24, ₹500+: 12)
 * - High-Margin Exemption: Products with >= 40% discount allowed up to warehouse stock
 * - Under-5% Margin Cap: Products with <= 15% discount capped at 12% cart share (₹6,000 baseline)
 * - Star Brand Cap: Combined ₹7,500 total cart value
 * - ₹50,000 Minimum Order Value (MOV) Checkout Gate & Progress Tracker
 * - 100% Stealth: No internal formulas or margins exposed
 */

(function() {
  window.dmartCartItems = window.dmartCartItems || {};
  window.dmartServerCartItems = window.dmartServerCartItems || {};
  window.dmartItemMetadata = window.dmartItemMetadata || {};
  window.dmartCartTotalPriceCents = 0;

  var debounceTimers = {};
  var latestSequence = 0;
  var WHOLESALE_MOV_CENTS = 5000000; // ₹50,000.00 in cents

  var STAR_KEYWORDS = ['maggi', 'parle', 'kissan', 'ching', 'paper boat', 'paperboat'];

  function formatMoney(cents) {
    var rupees = Math.round(cents / 100);
    return '₹' + rupees.toLocaleString('en-IN');
  }

  function formatMoneyExact(cents) {
    var rupees = (cents / 100).toFixed(2);
    return 'Rs. ' + rupees;
  }

  function getOptimisticTotalCount() {
    var total = 0;
    for (var vid in window.dmartCartItems) {
      total += (parseInt(window.dmartCartItems[vid], 10) || 0);
    }
    return total;
  }

  // Modern Wholesale Toast Notification
  function showWholesaleToast(message, type) {
    var existing = document.getElementById('gpw-wholesale-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'gpw-wholesale-toast';
    toast.className = 'gpw-wholesale-toast' + (type === 'warn' ? ' gpw-toast-warn' : '');
    toast.innerHTML = '<span class="gpw-toast-icon">' + (type === 'warn' ? '⚠️' : 'ℹ️') + '</span><span class="gpw-toast-msg">' + message + '</span>';

    document.body.appendChild(toast);

    requestAnimationFrame(function() {
      toast.classList.add('gpw-toast-visible');
    });

    setTimeout(function() {
      toast.classList.remove('gpw-toast-visible');
      setTimeout(function() {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 350);
    }, 4500);
  }

  // Extract / Cache Metadata from DOM Stepper or Card (Pure Price & Discount Driven)
  function getElementMeta(elem, variantId) {
    if (!elem && variantId && window.dmartItemMetadata[variantId]) {
      return window.dmartItemMetadata[variantId];
    }
    var card = elem ? (elem.closest('.dmart-grid-card') || elem.closest('.dmart-pdp-stepper-wrap') || elem.closest('.dmart-qty-stepper')) : null;
    var stepper = card ? (card.classList.contains('dmart-qty-stepper') ? card : card.querySelector('.dmart-qty-stepper')) : null;
    var vId = variantId || (stepper ? stepper.getAttribute('data-variant-id') : (card ? card.getAttribute('data-variant-id') : null));
    if (!vId) return null;
    vId = String(vId);

    if (window.dmartItemMetadata[vId] && !card) {
      return window.dmartItemMetadata[vId];
    }

    var maxStock = 9999;
    var rawStock = 9999;
    var price = 0;
    var discount = 0;
    var isStar = false;
    var isUnder5 = false;
    var isHighMargin = false;

    if (stepper) {
      maxStock = parseInt(stepper.getAttribute('data-max-stock') || '9999', 10);
      rawStock = parseInt(stepper.getAttribute('data-raw-stock') || stepper.getAttribute('data-max-stock') || '9999', 10);
      var prStr = stepper.getAttribute('data-price-rupees');
      price = prStr ? parseFloat(prStr) : (parseFloat(stepper.getAttribute('data-price') || '0') / 100);
      discount = parseFloat(stepper.getAttribute('data-discount') || '0');
      isStar = stepper.getAttribute('data-is-star') === 'true';
      isUnder5 = stepper.getAttribute('data-is-under-5') === 'true';
      isHighMargin = stepper.getAttribute('data-is-high-margin') === 'true';
    } else if (card) {
      maxStock = parseInt(card.getAttribute('data-max-stock') || '9999', 10);
      rawStock = parseInt(card.getAttribute('data-raw-stock') || card.getAttribute('data-max-stock') || '9999', 10);
      var prCardStr = card.getAttribute('data-price-rupees');
      price = prCardStr ? parseFloat(prCardStr) : (parseFloat(card.getAttribute('data-price') || '0') / 100);
      discount = parseFloat(card.getAttribute('data-discount') || '0');
      isStar = card.getAttribute('data-is-star') === 'true';
      isUnder5 = card.getAttribute('data-is-under-5') === 'true';
      isHighMargin = card.getAttribute('data-is-high-margin') === 'true';
    }

    // Pure Mathematical Fallbacks if not provided in DOM
    if (!isHighMargin && discount >= 25 && !isStar) isHighMargin = true;
    if (!isUnder5 && discount <= 15 && !isStar) isUnder5 = true;

    window.dmartItemMetadata[vId] = {
      maxStock: maxStock,
      rawStock: rawStock,
      price: price,
      discount: discount,
      isStar: isStar,
      isUnder5: isUnder5,
      isHighMargin: isHighMargin
    };
    return window.dmartItemMetadata[vId];
  }

  // Register Cart Item from /cart.js using Pure Price and Discount Mathematics
  function registerCartItemMeta(item) {
    var vId = String(item.variant_id || item.id);
    if (window.dmartItemMetadata[vId]) return window.dmartItemMetadata[vId];

    var vendor = (item.vendor || '').toLowerCase();
    var title = (item.title || '').toLowerCase();
    var fullText = vendor + ' ' + title;

    var originalPrice = item.original_line_price ? (item.original_line_price / item.quantity) : (item.price || 0);
    var priceCents = item.price || 0;
    var discountPct = 0;
    if (originalPrice > priceCents) {
      discountPct = Math.round(((originalPrice - priceCents) / originalPrice) * 100);
    }

    var isStar = STAR_KEYWORDS.some(function(k) { return fullText.indexOf(k) !== -1; });
    var isHighMargin = (discountPct >= 25) && !isStar;
    var isUnder5 = (discountPct <= 15); // Bracket 1 (< 7% margin)
    var isBracket2 = (discountPct > 15 && discountPct <= 25); // Bracket 2 (7% - 12% margin)

    var priceRupees = priceCents / 100.0;
    var maxStock = 9999;
    if (isHighMargin) {
      maxStock = 9999; // Recovery exemption: Full warehouse stock!
    } else if (isUnder5) {
      // Bracket 1 (< 7% margin): Staples / Oils / Atta
      if (priceRupees < 50) maxStock = 24;
      else if (priceRupees < 200) maxStock = 12;
      else if (priceRupees < 500) maxStock = 6;
      else maxStock = 4;
    } else if (isBracket2) {
      // Bracket 2 (7% - 12% margin): Maggi, Noodles, Fast Staples
      if (priceRupees < 50) maxStock = 48;
      else if (priceRupees < 200) maxStock = 24;
      else if (priceRupees < 500) maxStock = 12;
      else maxStock = 6;
    } else {
      // Bracket 3 (12% - 16% margin): Core FMCG
      if (priceRupees < 50) maxStock = 72;
      else if (priceRupees < 200) maxStock = 36;
      else if (priceRupees < 500) maxStock = 18;
      else maxStock = 10;
    }

    window.dmartItemMetadata[vId] = {
      maxStock: maxStock,
      rawStock: 9999,
      price: priceRupees,
      discount: discountPct,
      isStar: isStar,
      isUnder5: isUnder5,
      isBracket2: isBracket2,
      isHighMargin: isHighMargin
    };
    return window.dmartItemMetadata[vId];
  }

  // Calculate live Cart Breakdown for Dynamic Quota Allocations
  window.calculateCartBreakdown = calculateCartBreakdown;
  function calculateCartBreakdown() {
    var totalValue = 0;
    var totalCost = 0;
    var starTotal = 0;
    var under5Total = 0;
    var b2Total = 0;

    for (var vid in window.dmartCartItems) {
      var q = parseInt(window.dmartCartItems[vid] || 0, 10);
      if (q <= 0) continue;
      var meta = window.dmartItemMetadata[vid] || {};
      var p = meta.price || 0;
      var line = p * q;
      totalValue += line;

      // Real or calibrated wholesale cost
      var cost = meta.cost;
      if (typeof cost === 'undefined' || cost === null || cost <= 0) {
        if (meta.isHighMargin) {
          cost = p * 0.81; // ~19% store margin
        } else if (meta.isUnder5) {
          cost = p * 0.94; // ~6% store margin
        } else if (meta.isBracket2) {
          cost = p * 0.90; // ~10% store margin
        } else {
          cost = p * 0.86; // ~14% store margin
        }
      }
      totalCost += (cost * q);

      if (meta.isStar) starTotal += line;
      if (meta.isUnder5) under5Total += line;
      if (meta.isBracket2) b2Total += line;
    }

    var blendedMargin = totalValue > 0 ? (((totalValue - totalCost) / totalValue) * 100) : 0;

    return {
      totalValue: totalValue,
      totalCost: totalCost,
      blendedMargin: blendedMargin,
      starTotal: starTotal,
      under5Total: under5Total,
      b2Total: b2Total
    };
  }

  // Real-Time Governor: Clamps quantity based on Pure Price & Margin Limits
  window.clampQuantity = clampQuantity;
  function clampQuantity(variantId, requestedQty, elem) {
    variantId = String(variantId);
    if (requestedQty <= 0) return 0;

    var meta = getElementMeta(elem, variantId);
    if (!meta) meta = { maxStock: 9999, price: 0 };

    var staticCap = (meta.isHighMargin && meta.rawStock) ? meta.rawStock : (meta.maxStock || 9999);
    var price = meta.price || 0;
    var currentQty = parseInt(window.dmartCartItems[variantId] || 0, 10);
    var targetQty = requestedQty;

    // 1. Static Anti-hoarding limit vs Warehouse Stock
    if (targetQty > staticCap) {
      targetQty = staticCap;
      if (meta.isHighMargin) {
        showWholesaleToast('Only ' + staticCap + ' units available in warehouse stock.', 'info');
      } else {
        showWholesaleToast('Seller limit reached: The seller has limited this item to ' + staticCap + ' units per order.', 'warn');
      }
    }

    // 2. Star Brand Cap (₹7,500 Combined Cart Cap)
    if (meta.isStar && price > 0) {
      var breakdown = calculateCartBreakdown();
      var otherStarTotal = breakdown.starTotal - (currentQty * price);
      var newStarTotal = otherStarTotal + (targetQty * price);
      if (newStarTotal > 7500) {
        var remainingStarBudget = Math.max(0, 7500 - otherStarTotal);
        var maxAllowedUnits = Math.floor(remainingStarBudget / price);
        if (maxAllowedUnits > staticCap) maxAllowedUnits = staticCap;
        targetQty = Math.min(targetQty, maxAllowedUnits);
        showWholesaleToast('Seller limit reached: Promotional allocation limit reached for Star Brands (₹7,500 cap).', 'warn');
      }
    }

    // 3. Dynamic Margin Regulator disabled - Full wholesale quantity allowed

    return targetQty;
  }

  // Synchronize Header Badges and Cart Total Price Text
  function updateHeaderUI(count, totalPriceCents) {
    var countBadges = document.querySelectorAll('.dmart-cart-count, .cart-count-bubble, [data-cart-count]');
    countBadges.forEach(function(badge) {
      badge.textContent = count;
      if (count > 0) {
        badge.classList.remove('hidden');
        badge.style.display = 'inline-flex';
      } else {
        badge.classList.remove('hidden');
        badge.textContent = '0';
      }
      badge.classList.remove('dmart-badge-pop');
      void badge.offsetWidth;
      badge.classList.add('dmart-badge-pop');
    });

    if (typeof totalPriceCents !== 'undefined') {
      var priceLabels = document.querySelectorAll('.dmart-cart-btn .dmart-action-label, a[href*="/cart"] .dmart-action-label, .dmart-cart-price-label');
      priceLabels.forEach(function(el) {
        el.textContent = 'Cart (' + formatMoneyExact(totalPriceCents) + ')';
      });
      
      var accountLabels = document.querySelectorAll('a[href*="/account"] .dmart-action-label');
      accountLabels.forEach(function(el) {
        el.textContent = 'Account';
      });
    }
  }

  // Synchronize Variant Cards & Steppers UI
  function updateVariantCardsUI(variantId, qty) {
    var cards = document.querySelectorAll('.dmart-grid-card[data-variant-id="' + variantId + '"], [data-variant-id="' + variantId + '"]');
    cards.forEach(function(el) {
      var input = el.querySelector('.dmart-qty-step-input');
      var countSpan = el.querySelector('.dmart-qty-step-count');
      var stepper = el.classList.contains('dmart-qty-stepper') ? el : el.querySelector('.dmart-qty-stepper');

      if (input && document.activeElement !== input) {
        input.value = qty;
      }
      if (countSpan) {
        countSpan.textContent = qty;
      }
      if (stepper) {
        if (qty > 0) {
          stepper.classList.add('dmart-stepper-active');
        } else {
          stepper.classList.remove('dmart-stepper-active');
        }
      }
    });
  }

  // Synchronize Wholesale MOV Progress Bars and Checkout Gate
  window.updateWholesaleMOVUI = updateWholesaleMOVUI;
  function updateWholesaleMOVUI(totalCents) {
    var isMet = totalCents >= WHOLESALE_MOV_CENTS;
    var pct = Math.min(100, Math.round((totalCents / WHOLESALE_MOV_CENTS) * 100));
    var deficitCents = Math.max(0, WHOLESALE_MOV_CENTS - totalCents);

    var movContainers = document.querySelectorAll('.gpw-mov-container, #CartDrawer-MOV, #CartFooter-MOV');
    movContainers.forEach(function(container) {
      var bar = container.querySelector('.gpw-mov-progress-bar');
      var pill = container.querySelector('.gpw-mov-status-pill');
      var desc = container.querySelector('.gpw-mov-desc');

      if (bar) {
        bar.style.width = pct + '%';
        if (isMet) {
          bar.classList.add('is-met');
        } else {
          bar.classList.remove('is-met');
        }
      }

      if (pill) {
        if (isMet) {
          pill.textContent = '✓ Wholesale MOV Met';
          pill.classList.add('is-met');
        } else {
          pill.textContent = 'MOV: ₹50,000';
          pill.classList.remove('is-met');
        }
      }

      if (desc) {
        if (isMet) {
          desc.innerHTML = '✓ Minimum wholesale order value met! You are ready to checkout.';
          desc.classList.add('is-met');
        } else {
          desc.innerHTML = 'Add <strong>' + formatMoney(deficitCents) + '</strong> more to unlock wholesale checkout.';
          desc.classList.remove('is-met');
        }
      }
    });

    var breakdown = calculateCartBreakdown();
    var starExceeded = breakdown.starTotal > 7500;
    var marginMet = breakdown.blendedMargin >= 14.5;
    var canCheckout = isMet && !starExceeded && marginMet;

    // Auto-balance timer removed - No automatic cart slashing

    var checkoutButtons = document.querySelectorAll(
      'button[name="checkout"], .cart__checkout-button, #CartDrawer-Checkout, #checkout'
    );
    checkoutButtons.forEach(function(btn) {
      if (isMet) {
        btn.classList.remove('gpw-disabled', 'gpw-locked-btn');
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('title');
        btn.innerHTML = 'Proceed to Wholesale Checkout ➔';
      } else {
        btn.classList.add('gpw-disabled', 'gpw-locked-btn');
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('title', 'Wholesale Minimum Order Value is ₹50,000. Add ' + formatMoney(deficitCents) + ' more to proceed.');
        btn.innerHTML = '🔒 Min Order ₹50,000 (Add ' + formatMoney(deficitCents) + ' more)';
      }
    });

    var dynamicButtons = document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons');
    dynamicButtons.forEach(function(wrap) {
      if (isMet) {
        wrap.style.display = '';
      } else {
        wrap.style.display = 'none';
      }
    });
  }

  // Cart Data Processor
  function applyCartData(cart) {
    window.dmartCartTotalPriceCents = cart.total_price || 0;
    var hasPending = Object.keys(debounceTimers).length > 0;
    
    window.dmartServerCartItems = {};
    if (cart.items && cart.items.length > 0) {
      cart.items.forEach(function(item) {
        registerCartItemMeta(item);
        window.dmartServerCartItems[item.variant_id] = item.quantity;
        if (!hasPending) {
          window.dmartCartItems[item.variant_id] = item.quantity;
        }
      });
    }

    if (cart.item_count === 0 && !hasPending) {
      window.dmartCartItems = {};
    }

    updateHeaderUI(cart.item_count, cart.total_price);
    updateWholesaleMOVUI(cart.total_price);

    if (!hasPending) {
      document.querySelectorAll('.dmart-grid-card, .dmart-qty-stepper, .dmart-pdp-stepper-wrap').forEach(function(card) {
        var vId = card.getAttribute('data-variant-id');
        if (!vId) return;
        var qty = window.dmartCartItems[vId] || 0;
        updateVariantCardsUI(vId, qty);
      });
    }
  }

  window.dmartSyncCartState = function(cartData) {
    if (cartData && cartData.items) {
      applyCartData(cartData);
      return;
    }
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        applyCartData(cart);
      })
      .catch(function(err) {
        console.error('Error syncing cart:', err);
      });
  };

  function dispatchCartUpdate(variantId, targetQty, reqSeq) {
    variantId = String(variantId);
    var serverQty = parseInt(window.dmartServerCartItems[variantId] || 0, 10);

    var endpoint = (serverQty === 0 && targetQty > 0) ? '/cart/add.js' : '/cart/change.js';

    // Immediately record targetQty optimistically so in-flight / subsequent requests NEVER call /cart/add.js again (prevents 6 -> 12 -> 18 jumps)
    if (targetQty > 0) {
      window.dmartServerCartItems[variantId] = targetQty;
    } else {
      delete window.dmartServerCartItems[variantId];
    }

    var bodyPayload = (endpoint === '/cart/add.js')
      ? JSON.stringify({ items: [{ id: variantId, quantity: targetQty }] })
      : JSON.stringify({ id: variantId, quantity: targetQty });

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: bodyPayload
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Cart API response error');
      return res.json();
    })
    .then(function() {
      return fetch('/cart.js', { cache: 'no-store' }).then(function(r) { return r.json(); });
    })
    .then(function(freshCart) {
      if (reqSeq >= latestSequence) {
        applyCartData(freshCart);
      }
    })
    .catch(function(err) {
      console.error('Cart update failed for variant ' + variantId + ':', err);
      window.dmartSyncCartState();
    });
  }

  function queueCartUpdate(variantId, newQty, immediate) {
    latestSequence++;
    var currentSeq = latestSequence;

    if (debounceTimers[variantId]) {
      clearTimeout(debounceTimers[variantId]);
      delete debounceTimers[variantId];
    }

    if (immediate) {
      dispatchCartUpdate(variantId, newQty, currentSeq);
    } else {
      debounceTimers[variantId] = setTimeout(function() {
        delete debounceTimers[variantId];
        dispatchCartUpdate(variantId, newQty, currentSeq);
      }, 250);
    }
  }

  // 1. Direct Typing Input Handler (0ms + Governor)
  window.dmartSetQty = function(variantId, rawValue, inputElem) {
    variantId = String(variantId);
    var requestedQty = parseInt(rawValue, 10);
    if (isNaN(requestedQty) || requestedQty < 0) requestedQty = 0;

    var finalQty = clampQuantity(variantId, requestedQty, inputElem);

    if (inputElem) inputElem.value = finalQty;

    // Ignore duplicate events (prevents Enter key + blur double submission)
    if (window.dmartCartItems[variantId] === finalQty && window.dmartServerCartItems[variantId] === finalQty) {
      return;
    }

    // 0ms Instant UI update
    window.dmartCartItems[variantId] = finalQty;
    updateVariantCardsUI(variantId, finalQty);
    updateHeaderUI(getOptimisticTotalCount());

    // Update wholesale MOV prediction optimistically
    var breakdown = calculateCartBreakdown();
    updateWholesaleMOVUI(Math.round(breakdown.totalValue * 100));

    // Debounce the server update so rapid Enter/blur events do not fire duplicate HTTP requests
    queueCartUpdate(variantId, finalQty, false);
  };

  // 2. Fast Step Click Handler (+ / -) (0ms + Governor + Sequence Lock)
  window.dmartUpdateQty = function(variantId, changeDelta, btnElem) {
    variantId = String(variantId);
    var currentQty = parseInt(window.dmartCartItems[variantId] || 0, 10);

    if (isNaN(currentQty) || currentQty === 0) {
      var card = btnElem ? (btnElem.closest('.dmart-grid-card') || btnElem.closest('.dmart-pdp-stepper-wrap') || btnElem.closest('.dmart-qty-stepper')) : null;
      var input = card ? card.querySelector('.dmart-qty-step-input') : null;
      if (input) currentQty = parseInt(input.value || '0', 10);
    }

    var requestedQty = currentQty + changeDelta;
    if (requestedQty < 0) requestedQty = 0;

    var finalQty = clampQuantity(variantId, requestedQty, btnElem);

    // 0ms Instant UI update
    window.dmartCartItems[variantId] = finalQty;
    updateVariantCardsUI(variantId, finalQty);
    updateHeaderUI(getOptimisticTotalCount());

    // Update wholesale MOV prediction optimistically
    var breakdown = calculateCartBreakdown();
    updateWholesaleMOVUI(Math.round(breakdown.totalValue * 100));

    // Debounced step queue with sequence lock
    queueCartUpdate(variantId, finalQty, false);
  };

  // Silent Profit Balancer & Auto-Reducer
  // Automatically trims lowest-margin staple quantities if cart profit drops below 15%
  var isBalancingCart = false;

  // autoBalanceCartProfits neutralized to prevent silent quantity slashing
  window.autoBalanceCartProfits = function(onComplete) {
    if (typeof onComplete === 'function') onComplete(false);
  };

  // Validation Engine: MOV ₹50k, Star Cap ₹7.5k, Silent Margin Auto-Balancing
  function validateWholesaleCheckoutIntegrity(e) {
    var totalCents = window.dmartCartTotalPriceCents || 0;

    // 1. Check MOV
    if (totalCents < WHOLESALE_MOV_CENTS) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
      var deficitCents = WHOLESALE_MOV_CENTS - totalCents;
      showWholesaleToast('Wholesale Minimum Order Value is ₹50,000. Add ' + formatMoney(deficitCents) + ' more to place your order.', 'warn');
      return false;
    }

    // 2. Check Star Product Cap (Max ₹7,500)
    var breakdown = calculateCartBreakdown();
    if (breakdown.starTotal > 7500) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
      var excess = Math.ceil(breakdown.starTotal - 7500);
      showWholesaleToast('Star brand promotional products (Maggi, Parle, Kissan, Ching\'s) exceed the ₹7,500 cart limit by ₹' + excess + '. Please reduce quantity to proceed.', 'warn');
      return false;
    }

    // Silent Blended Profit Check removed: Customer cart is not trimmed at checkout.

    return true;
  }

  // 3. MOV, Star Cap & Margin Checkout Click Interceptor
  document.addEventListener('click', function(e) {
    var checkoutBtn = e.target.closest(
      'button[name="checkout"], .cart__checkout-button, #CartDrawer-Checkout, #checkout, [href*="/checkout"]'
    );
    if (!checkoutBtn) return;
    if (!validateWholesaleCheckoutIntegrity(e)) {
      return false;
    }
  }, true);

  // 4. Form Submission Interceptor for Cart
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form && (form.id === 'CartDrawer-Form' || form.id === 'cart' || (form.action && form.action.indexOf('/cart') !== -1))) {
      if (!validateWholesaleCheckoutIntegrity(e)) {
        return false;
      }
    }
  }, true);

  // Initial Sync
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.dmartSyncCartState);
  } else {
    window.dmartSyncCartState();
  }
})();
